import ArchetypeGuardian from './ArchetypeGuardian'

export default ArchetypeGuardian
// eslint-disable-next-line import/export
export * from './ArchetypeGuardian'
